"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditableCompetitorTable;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _GuaranteedLifetimeWithdrawalBenefitWizardFormControls = require("./GuaranteedLifetimeWithdrawalBenefitWizardFormControls");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _EditableCompetitorViews = require("./EditableCompetitorViews");
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function EditableCompetitorTable(_ref) {
  var {
    setIsEditable,
    arraySelection,
    setShowToast,
    hasCompetitorDataChanged,
    setHasCompetitorDataChanged
  } = _ref;
  var {
    errors,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    // Starting at the 1st row, we want to see if the first endAge has been touched
    // If the endAge has been touched, we want to increment the next row's startAge by 1
    // so if endAge[1] = 65, then startAge[2] should be startAge[2] = value at endAge[1] + 1
    for (var i = 0; i <= values[arraySelection].length - 1; i++) {
      if (i === 0) {
        setFieldValue("".concat(arraySelection, "[").concat(i, "].startAge"), 0);
      } else {
        var incrementedStartAge = values[arraySelection][i - 1].endAge ? Math.min(99, Number(values[arraySelection][i - 1].endAge) + 1) : values[arraySelection][i - 1].startAge;
        setFieldValue("".concat(arraySelection, "[").concat(i, "].startAge"), incrementedStartAge);
      }
    }
  }, [values[arraySelection]]);

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);

  // By default when user lands on this editable view we should not show a "Competitor information updated" toast,
  // we should only show the toast when the user has actually made a change to any of the default values
  var isInitialRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      setShowToast(false);
      return;
    }
    setShowToast(true);
    setHasCompetitorDataChanged(true);
  }, [values[arraySelection], values.rollUpRate, values.rollUpPeriod, values.interestRollUp]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
    className: "zircon-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-desktop-tablet-only"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "glwb less-margin-bottom"
  }, "Add Your Own Competitor Information")), /*#__PURE__*/_react.default.createElement("p", {
    className: "small mm-text-center"
  }, "Input information for a competitor you're familiar with.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "glwb less-margin-bottom"
  }, "Add Your Own Competitor Information")), /*#__PURE__*/_react.default.createElement("p", null, "Input information for a competitor you're familiar with.")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(_EditableCompetitorViews.EditableRatesCardDesktopTabletView, {
    arraySelection: arraySelection
  }), /*#__PURE__*/_react.default.createElement(_EditableCompetitorViews.EditableRatesCardMobileView, {
    arraySelection: arraySelection
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(CollapseAgeWithdrawalInfo, null))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-8 col-sm-12 rollup"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-md-5"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: 'rollUpRate'
  }, "Roll-up rate")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-lg-5 no-padding-sides"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.RollUpRate, {
    errors: errors,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-md-5"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: 'rollUpPeriod'
  }, "Roll-up period")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-lg-5 no-padding-sides"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.RollUpPeriod, {
    errors: errors,
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-md-5"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: 'interestRollUp'
  }, "Interest type")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 col-lg-5 no-padding-sides"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.Interest, {
    errors: errors,
    values: values,
    setFieldValue: setFieldValue
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/_react.default.createElement(CollapseRollupInterestInfo, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "secondary",
    type: "submit",
    disabled: Object.keys(errors).length === 0 ? false : true,
    onClick: () => {
      (0, _utils.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'doneButton');
      if (Object.keys(errors).length === 0) {
        setIsEditable(false);
        hasCompetitorDataChanged ? setShowToast(true) : '';
        setHasCompetitorDataChanged(false);
      }
    }
  }, "Done")))));
}
function CollapseAgeWithdrawalInfo() {
  var [item, setItem] = (0, _react.useState)('');
  var handleItemClick = eventKey => () => {
    setItem(item === eventKey ? null : eventKey);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb-info-collapse"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: "0",
    open: item === '0',
    onClick: handleItemClick('0')
  }, /*#__PURE__*/_react.default.createElement("h4", null, "How to complete this section")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "small-line-height"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Age range:"), " Each row of inputs represents a GLWB age band, with the starting age featured on the left and the last age featured on the right. To edit this information:"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, "1. Enter the last age for each age band in the right-side input of each \"Age range\" row."), /*#__PURE__*/_react.default.createElement("span", null, "2. Use the \"Remove\" button to remove any unneeded row. Click \"Add row\" to add a row."), /*#__PURE__*/_react.default.createElement("span", null, "3. Enter an age up to 99 as the last age in the last row.")), /*#__PURE__*/_react.default.createElement("p", {
    className: "small-line-height"
  }, "Note: The withdrawal rate for the first row is", ' ', /*#__PURE__*/_react.default.createElement("strong", null, "always 0%"), ". With this, ensure that the age you enter in the first \"Age range\" row is the last age ", /*#__PURE__*/_react.default.createElement("em", null, "before"), " the competitor begins offering lifetime income. Ex: If lifetime income becomes available starting at age 58, enter age 57 as the last age in the first row."), /*#__PURE__*/_react.default.createElement("p", {
    className: "small-line-height"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Withdrawal rate:"), " For each age band, enter the corresponding withdrawal rate. Do not leave any withdrawal rate field blank.")))));
}
function CollapseRollupInterestInfo() {
  var [item, setItem] = (0, _react.useState)('');
  var handleItemClick = eventKey => () => {
    setItem(item === eventKey ? null : eventKey);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb-info-collapse"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: "0",
    open: item === '0',
    onClick: handleItemClick('0')
  }, /*#__PURE__*/_react.default.createElement("h4", null, "How to complete this section")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "small-line-height"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Roll-up rate:"), " Enter the roll-up rate for the other GLWB. Note: Traditional roll-ups are between 4%-6%."), /*#__PURE__*/_react.default.createElement("p", {
    className: "small-line-height"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Roll-up period:"), " Select the roll-up period to be applied to the benefit base."), /*#__PURE__*/_react.default.createElement("p", {
    className: "small-line-height"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Interest:"), " Select whether the benefit base roll-up is Simple or Compound.")))));
}